<template>
  <rect width="90" height="48" rx="3" fill="#3E3E3E" />
  <rect x="12.5" y="10.5" width="53" height="27" rx="2.5" fill="#525252" />
  <rect x="22" y="21" width="34" height="6" rx="2" fill="#F9F9F9" />
  <rect x="12.5" y="10.5" width="53" height="27" rx="2.5" stroke="#5B5B5B" />
  <rect x="72.5" y="10.5" width="45" height="27" rx="2.5" fill="#525252" />
  <rect x="79" y="21" width="32" height="6" rx="2" fill="#757575" />
  <rect x="72.5" y="10.5" width="45" height="27" rx="2.5" stroke="#5B5B5B" />
</template>
